(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('MedicineDeleteController',MedicineDeleteController);

    MedicineDeleteController.$inject = ['$uibModalInstance', 'entity', 'Medicine'];

    function MedicineDeleteController($uibModalInstance, entity, Medicine) {
        var vm = this;
        vm.medicine = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Medicine.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
